import { ReactNode } from 'react';

import { SkeletonRectangularImageLoading, SkeletonTextLoading } from '.';

export const SkeletonElementLoading = ({
  children,
  type = 'text',
  loading,
}: {
  children: ReactNode;
  type?: 'text' | 'gallery';
  loading?: boolean;
}) => {
  if (loading) {
    if (type === 'text') return <SkeletonTextLoading width="medium" />;
    if (type === 'gallery') return <SkeletonRectangularImageLoading />;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
